<template>
  <div class="bundleWrapper">
    <error-notification
      v-if="isAuthorised === false"
      message="U heeft geen toegang tot deze bundel. Is dit onjuist, neem dan contact op met de beheerder om de bundel toe te voegen aan uw account.">
    </error-notification>

    <template v-else>
      <my-title v-if="bundle">{{ bundle.name }}</my-title>

      <h2 v-if="bundle" class="subtitle is-6">{{ getDossierName(bundle.dossier_nr, bundle.profile_nr) }}</h2>

      <div class="tabs no-print">
        <ul>
          <li :class="{ 'is-active': this.$route.name === 'values' }"><router-link :to="{ name: 'values'}" class="navbar-item">Basislijst</router-link></li>
          <li :class="{ 'is-active': this.$route.name === 'datasets' }"><router-link :to="{ name: 'datasets'}" class="navbar-item">Tabellen</router-link></li>
          <li :class="{ 'is-active': this.$route.name === 'reports' }"><router-link :to="{ name: 'reports'}" class="navbar-item">Rapporten</router-link></li>
          <li :class="{ 'is-active': this.$route.name === 'pages' }"><router-link :to="{ name: 'pages'}" class="navbar-item">Content</router-link></li>
        </ul>
      </div>

      <router-view></router-view>
    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { authMixin } from '@/mixins'
import DossierMixin from '@/mixins/dossiers'
import MyTitle from '@/components/modules/Title'
import ErrorNotification from '@/components/modules/ErrorNotification'

export default {
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.getAuthorisation(to.params.bundleId)
      if (vm.isAuthorised) {
        vm.$store.dispatch('bundles/load', to.params.bundleId)
      }
    })
  },

  beforeRouteUpdate (to, from, next) {
    this.getAuthorisation(to.params.bundleId)
    next()
  },

  beforeRouteLeave (to, from, next) {
    this.$store.commit('bundles/RESET')
    this.$store.commit('users/SET_AUTHORISATION', { isAuthorised: null })
    next()
  },

  mixins: [
    authMixin,
    DossierMixin
  ],

  components: {
    MyTitle,
    ErrorNotification
  },

  computed: {
    ...mapGetters({
      bundle: 'bundles/bundle',
      source: 'dossiers/source',
      account: 'account/account',
      dossiers: 'dossiers/dossiers',
      isAuthorised: 'users/isAuthorised'
    })
  },

  watch: {
    isAuthorised () {
      if (this.isAuthorised) {
        this.getBundle()
      }
    }
  },

  methods: {
    getAuthorisation (bundleId) {
      this.$store.dispatch('users/getAuthorisation', {
        bundleId: bundleId
      })
    },

    getBundle () {
      this.$store.dispatch('bundles/load', this.$route.params.bundleId)
    }
  }
}
</script>
